import pathToRegexp from 'path-to-regexp';
import EventEmitter2 from 'eventemitter2';

class Router extends EventEmitter2 {

  constructor() {
    super();
    this._rules = [];
  }

  route(path, callback) {
    const rule = { path, callback };
    this._rules.push(rule);
  }

  unroute(path, callback) {

    let swipeIfNeeded = false;

    this._rules.forEach((rule, index, rules) => {

      if(rule.hasOwnProperty(path)) {

        //1. callback指定がない場合、マッチするpathを全て外す
        //2. callback指定があったら、そのcallbackが指定されているpathのみ外す
        if(!callback || rule.callback === callback) {
          rules[index] = null;
          swipeIfNeeded = true;
        }
      }
    });

    if(swipeIfNeeded) {
      const nextRules = [];

      this._rules.forEach((rule) => {
        nextRules.push(rule);
      });

      this._rules = nextRules;
    }
  }

  exec(pathname) {

    this._rules.forEach(({ path, callback }, index) => {

      const keys = [];
      const pathRe = pathToRegexp(path, keys);
      const result = pathRe.exec(pathname);


      if(result) {
        const tokens = {};

        // keysの配列に長さがあった場合、resultはarrayになっている
        keys.forEach((keyInfo, index) => {
          tokens[keyInfo.name] = result[index+1];
        });

        callback(pathname, tokens);
      }
    });
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/js/app/router.js